import { setPostLoginRedirect } from "./PostLoginRedirect";
import { showNotification } from "./Toast";

// Espelha NoAuthRoutes.AdminLogin.path (Routes/Components/NoAuth.js).
//
// ⚠️ Literal de propósito: importar `Routes/Components/NoAuth` aqui arrastaria a
// árvore de páginas (AdminLogin → design-system → ESM) para dentro de um helper
// que praticamente todo módulo importa — e suíte que não carrega some do total
// sem nenhum ✕. Um teste trava a coerência entre as duas.
const ADMIN_LOGIN_PATH = "/admin";

const getErrorMessage = (error) => {
  if (error.status === 404) return "Solicitação não encontrada!";

  return "Houve um erro inesperado!";
};

export const HTTPErrorCallback = (errorReponse, onRemove) => {
  const error = errorReponse.response;

  const disconnectUser = () => {
    const current = window.location.pathname + window.location.search;

    // Guarda o destino ANTES de limpar a sessão: depois do login o usuário volta
    // para cá, em vez de refazer o caminho à mão (24/09/2026). Rota pública e
    // tela de login são recusadas pelo próprio helper.
    setPostLoginRedirect(current);

    localStorage.removeItem("userJWTToken");
    localStorage.removeItem("oldJWTToken");

    /*
     * Navegação real (não reload), garantindo saída de rotas admin.
     *
     * ⚠️ O destino sai do CAMINHO ATUAL, não do `isAdmin` do contexto: neste
     * ponto o token já é inválido, e o `isAdmin` do UseAuth nunca volta a false.
     * Quem estava no admin volta para a tela de login do admin; antes caía na
     * home de proponente e precisava achar o modal de login.
     */
    window.location.href = window.location.pathname.startsWith("/admin")
      ? ADMIN_LOGIN_PATH
      : "/";
  };

  if (error?.data) {
    showNotification(
      "danger",
      "Atenção!",
      error?.data?.body?.error || error?.data?.error || getErrorMessage(error),
      () => {
        onRemove && onRemove();
        error.data.disconnect_user && disconnectUser();
      },
    );
  } else {
    showNotification("danger", "Atenção", "Houve um erro inesperado!");
  }
};
